export default "__VITE_ASSET__BYEhrT9H__"